import { render, staticRenderFns } from "./WarningsIntro.vue?vue&type=template&id=cca1d604&"
import script from "./WarningsIntro.vue?vue&type=script&lang=js&"
export * from "./WarningsIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports